/**
 * Gateway picker (when required) + static tag for copy-as-draft.
 */

import type { FC } from 'react';
import { Route } from 'lucide-react';

import { SearchableSelect } from '@/components/ui';
import { StaticTagsPickerSection } from '@/features/smswiser-campaigns/components/drop-modals';
import type { DropsWithStatsRow } from '@/features/smswiser-campaigns/types/workspace.types';

export interface CopyAsDraftGatewayAndTagsProps {
  dropsNeedingGateway: DropsWithStatsRow[];
  gatewayOptions: { value: number; label: string }[];
  singleGatewayValue: number;
  onBulkGatewayChange: (gatewayId: number) => void;
  staticTagId: string | null;
  onStaticTagChange: (id: string | null) => void;
}

export const CopyAsDraftGatewayAndTags: FC<CopyAsDraftGatewayAndTagsProps> = ({
  dropsNeedingGateway,
  gatewayOptions,
  singleGatewayValue,
  onBulkGatewayChange,
  staticTagId,
  onStaticTagChange,
}) => (
  <>
    {dropsNeedingGateway.length > 0 && (
      <div className="flex flex-col gap-2">
        <label className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
          <Route className="h-3.5 w-3.5 shrink-0" aria-hidden />
          Gateway (required for {dropsNeedingGateway.length} drop{dropsNeedingGateway.length !== 1 ? 's' : ''}{' '}
          without gateway)
        </label>
        <SearchableSelect<number>
          options={gatewayOptions}
          value={singleGatewayValue}
          onChange={onBulkGatewayChange}
          placeholder="Select gateway"
          searchPlaceholder="Search gateways..."
          className="min-w-0"
        />
      </div>
    )}
    <div className="flex flex-col gap-2">
      <StaticTagsPickerSection mode="single" selectedId={staticTagId} onChange={onStaticTagChange} compact />
    </div>
  </>
);
